import PropTypes from "prop-types";

export const productPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
    term: PropTypes.string.isRequired,
    premium: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        period: PropTypes.string.isRequired,
    }).isRequired,
});
